import * as React from "react";

const JiminnyIcon = (props: { width?: number; height?: number }) => (
  <img
    src="/JiminnyLogo.png"
    alt="Jiminny"
    width={props.width ?? 25}
    height={props.height ?? 25}
    style={{ objectFit: "contain" }}
  />
);

export default JiminnyIcon;
